export const TrialKey = {
  properties: {
    company: {
      type: 'string',
      minLength: 2,
      maxLength: 255
    },
    email: {
      type: 'string',
      minLength: 5,
      maxLength: 255,
      format: 'email'
    },
    domains: {
      type: 'array',
      minItems: 1,
      maxItems: 20,
      uniqueItems: true,
      items: {
        type: 'string'
      }
    },
    repository: {
      anyOf: [
        {
          type: 'string',
          format: 'url'
        },
        { type: 'string', maxLength: 0 }
      ]
    }
  },
  required: ['company', 'email', 'domains']
};
